export default __webpack_public_path__ + "static/media/Assets.7a2d4bee.png";